import { CURSOR_MODES, DEFAULT_THEME_SETTINGS, EFFECT_MODES, THEME_PRESETS } from "../../config/themeConfig";

const STORAGE_KEY = "freedom_theme_settings_v1";

function clamp(value, min, max) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return min;
  return Math.min(max, Math.max(min, numeric));
}

function pickAllowed(value, allowed, fallback) {
  return allowed.includes(value) ? value : fallback;
}

export function sanitizeThemeSettings(input = {}) {
  const presetIds = THEME_PRESETS.map((item) => item.id);
  const cursorIds = CURSOR_MODES.map((item) => item.id);
  const effectIds = EFFECT_MODES.map((item) => item.id);

  return {
    presetId: pickAllowed(input.presetId, presetIds, DEFAULT_THEME_SETTINGS.presetId),
    starDensity: clamp(input.starDensity, 0.4, 2.4),
    starSpeed: clamp(input.starSpeed, 0.6, 2.4),
    twinkleIntensity: clamp(input.twinkleIntensity, 0.6, 2.2),
    nebulaIntensity: clamp(input.nebulaIntensity, 0.4, 1.9),
    effectIntensity: clamp(input.effectIntensity, 0.5, 2.2),
    cursorMode: pickAllowed(input.cursorMode, cursorIds, DEFAULT_THEME_SETTINGS.cursorMode),
    effectMode: pickAllowed(input.effectMode, effectIds, DEFAULT_THEME_SETTINGS.effectMode),
  };
}

export function loadThemeSettings() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_THEME_SETTINGS;
    const parsed = JSON.parse(raw);
    return sanitizeThemeSettings(parsed);
  } catch {
    return DEFAULT_THEME_SETTINGS;
  }
}

export function saveThemeSettings(payload) {
  try {
    const settings = sanitizeThemeSettings(payload);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch {
    // no-op
  }
}

export function resetThemeSettings() {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // no-op
  }
}

export { STORAGE_KEY as THEME_SETTINGS_STORAGE_KEY };
